// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function penaltyEnum_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */0) {
      var description = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
      if (description.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  id: id._0,
                  name: name._0,
                  description: description._0
                }
              };
      }
      var e = description._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".description" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".name" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var penalty_enums = Decco.listFromJson(penaltyEnum_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "penalty_enums"), null));
  if (penalty_enums.TAG === /* Ok */0) {
    var order_id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_id"), null));
    if (order_id.TAG === /* Ok */0) {
      var order_time = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_time"), null));
      if (order_time.TAG === /* Ok */0) {
        var driver_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "driver_name"), null));
        if (driver_name.TAG === /* Ok */0) {
          var msisdn = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "msisdn"), null));
          if (msisdn.TAG === /* Ok */0) {
            var vehicle_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_type"), null));
            if (vehicle_type.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        penalty_enums: penalty_enums._0,
                        order_id: order_id._0,
                        order_time: order_time._0,
                        driver_name: driver_name._0,
                        msisdn: msisdn._0,
                        vehicle_type: vehicle_type._0
                      }
                    };
            }
            var e = vehicle_type._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".vehicle_type" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = msisdn._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".msisdn" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = driver_name._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".driver_name" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = order_time._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".order_time" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = order_id._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".order_id" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = penalty_enums._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".penalty_enums" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

export {
  penaltyEnum_decode ,
  t_decode ,
  
}
/* No side effect */
